"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ChartContext_1 = require("../../context/ChartContext");
const ScaleContext_1 = require("../../context/ScaleContext");
const ToolTypes_1 = require("../../toolbar/ToolTypes");
const styles = {
    transformOrigin: 'top left',
    position: 'absolute',
    top: '0px',
    left: '0px',
    width: 1,
    backgroundColor: 'red',
};
function VerticalIndicator() {
    const { height, toolOptions: { selectedTool, data: { pivot }, }, } = (0, ChartContext_1.useChartData)();
    const { scaleX } = (0, ScaleContext_1.useScaleChecked)();
    if (ToolTypes_1.options.phaseCorrection.id !== selectedTool)
        return null;
    return ((0, jsx_runtime_1.jsx)("div", { style: {
            ...styles,
            transform: `translate(${scaleX()(pivot.value)}px, 0px)`,
            height,
        } }));
}
exports.default = VerticalIndicator;
